import * as spritejs from 'spritejs';
const { Label, Group } = spritejs;

const createItem = (menuList) => {
    const group = new Group({
        width: 110,
        bgcolor: '#fff',
        boxSizing: 'border-box',
        border: [1, 'rgba(0,0,0,0.5)'],
        padding:[5,5,5,5],
        borderRadius: 5,
        clipOverflow: true
    });
    for (let i = 0, len = menuList.length; i < len; i++) {
        const text = new Label(menuList[i].label);
        text.attr({
            pos: [0, (i * 25)+5],
            width: 110,
            padding: [5, 5, 5, 15],
            fillColor: '#525252',
            font: '15px Arial',
        })
        text.addEventListener('mouseenter',(e)=>{
            e.stopPropagation();
            text.attr({
                fillColor:'#cc6666'
            })
            
        })
        text.addEventListener('mouseleave',(e)=>{
            e.stopPropagation();
            text.attr({
                fillColor:'#525252'
            })
            
        })
        text.addEventListener('click',(e)=>{
            // e.stopPropagation();
            menuList[i].onclick && menuList[i].onclick(e);
        })
        group.append(text);
    }
    group.attr({
        height: menuList.length * 30
    })
    return group;
}

export const context = (menu = [{ label: "复制", val: "clone", key: "copy" }, { label: "删除", val: "delete", key: "del" }], layer) => {
    const mask = new Group({
        width: innerWidth,
        height: innerHeight,
        pos: [0, 0],
        zIndex: 9999,
    });
    const group = createItem(menu);
    mask.append(group);
    mask.hide = () => {
        mask.attr({
            display: 'none',
        })
    }
    mask.show = () => {
        mask.attr({
           display: 'block',
        })
    }

    let $layer = null;
    layer.addEventListener('contextmenu', (e) => {
        e.stopPropagation()
        const target = e.target;
        $layer = target.layer;
        let layerX = e.layerX;
        let layerY = e.layerY;
        group.attr({
            pos: [layerX, layerY]
        })
        $layer && $layer.append(mask);
    })

    mask.addEventListener('click', (e) => {
        $layer && $layer.removeChild(mask);
    })

    return mask;
}